import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/main.css";

Vue.config.productionTip = false;

new Vue({
  router: router,
  render: function render(h) {
    return h(App);
  }
}).$mount("#app");
